// Accessibility helpers (roadmap #64). Many rows in the magazine skin are
// <div role="button"> (they hold buttons of their own, which a <button> can't).
// Make every one of them reachable with Tab and pressable with Enter / Space,
// like a real button — once, for the whole app.

export function installButtonRoles(root = document) {
	const mark = (node) => {
		if (node.nodeType !== 1) return;
		const all = node.matches?.('[role="button"]') ? [node] : [];
		for (const el of [...all, ...(node.querySelectorAll?.('[role="button"]:not([tabindex])') ?? [])]) {
			if (!el.hasAttribute("tabindex")) el.tabIndex = 0;
		}
	};
	mark(root.body ?? root);
	new MutationObserver((records) => {
		for (const r of records) for (const n of r.addedNodes) mark(n);
	}).observe(root.body ?? root, { childList: true, subtree: true });

	root.addEventListener("keydown", (e) => {
		if (e.key !== "Enter" && e.key !== " ") return;
		const t = e.target;
		if (!(t instanceof HTMLElement) || t.getAttribute("role") !== "button" || t.tagName === "BUTTON") return;
		e.preventDefault();
		t.click();
	});
}
